<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Chapter-rw" epub:type="bodymatter chapter" id="dedication">
<p class="dedication"><span><em>For those in my family who traveled far in company of service members, and those who waited at home in times of war:</em></span></p>
<p class="dedication1"><span><em>Florence Bear</em></span></p>
<p class="ded"><span><em>Earl Bear</em></span></p>
<p class="ded"><span><em>Irene Garrett</em></span></p>
<p class="ded"><span><em>George Garrett</em></span></p>
<p class="ded"><span><em>Lorraine Garrett</em></span></p>
<p class="ded"><span><em>Lynn Garrett</em></span></p>
<p class="ded"><span><em>Dan Garrett</em></span></p>
<p class="ded"><span><em>Kathleen Garrett</em></span></p>
<p class="ded"><span><em>Colleen Garrett</em></span></p>
<p class="ded"><span><em>Devin Garrett</em></span></p>
<p class="ded"><span><em>Barbara Julian</em></span></p>
<p class="ded"><span><em>Wilma Bear</em></span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?ec317d62